import { ApiMethod } from '@wajeez-web/stores/base';
import { AlertType, CommonActions } from '@wajeez-web/stores/common';
import { paymentClient, Server } from '@wajeez-web/core/api-base';

export const getProductGroupsLookups: ApiMethod<
  { searchText?: string | undefined },
  Server.ProductGroupOutput[]
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_ProductGroup_Client(
      undefined,
      paymentClient
    );

    const response = await client.productGroup_lookup_get_V1(data.searchText);

    if (response.success && response.data) {
      return response.data;
    }

    return rejectWithValue(response.errors);
  } catch (error: any) {
    const errors = JSON.parse(error.response).errors;

    dispatch(
      CommonActions.setAlert({
        show: true,
        type: AlertType.ERROR,
        messages: errors || [{ message: 'Something went wrong' }],
      })
    );

    return rejectWithValue(errors);
  }
};

export const getProductGroupsDatatable: ApiMethod<
  Server.GetProductGroupsDatatableInput,
  Server.TableOfProductGroupColumns
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_ProductGroup_Client(
      undefined,
      paymentClient
    );

    const response = await client.productGroup_datatable_post_V1(data);

    if (response.success && response.data) {
      return response.data;
    }

    return rejectWithValue(response.errors);
  } catch (error: any) {
    const errors = JSON.parse(error.response).errors;

    dispatch(
      CommonActions.setAlert({
        show: true,
        type: AlertType.ERROR,
        messages: errors || [{ message: 'Something went wrong' }],
      })
    );

    return rejectWithValue(errors);
  }
};

export const createProductGroup: ApiMethod<
  Server.CreateProductGroupInput,
  Server.ProductGroupOutput
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_ProductGroup_Client(
      undefined,
      paymentClient
    );

    const response = await client.productGroup_post_V1(data);

    if (response.success && response.data) {
      return response.data;
    }

    return rejectWithValue(response.errors);
  } catch (error: any) {
    const errors = JSON.parse(error.response).errors;

    dispatch(
      CommonActions.setAlert({
        show: true,
        type: AlertType.ERROR,
        messages: errors || [{ message: 'Something went wrong' }],
      })
    );

    return rejectWithValue(errors);
  }
};

export const editProductGroup: ApiMethod<
  Server.UpdateProductGroupInput,
  void
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_ProductGroup_Client(
      undefined,
      paymentClient
    );

    const response = await client.productGroup_put_V1(data);

    if (response.success) {
      return;
    }

    return rejectWithValue(response.errors);
  } catch (error: any) {
    const errors = JSON.parse(error.response).errors;

    dispatch(
      CommonActions.setAlert({
        show: true,
        type: AlertType.ERROR,
        messages: errors || [{ message: 'Something went wrong' }],
      })
    );

    return rejectWithValue(errors);
  }
};

export const getProductGroupById: ApiMethod<
  number,
  Server.ProductGroupOutput
> = async (id, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_ProductGroup_Client(
      undefined,
      paymentClient
    );

    const response = await client.productGroup_byId_get_V1(id);

    if (response.success && response.data) {
      return response.data;
    }

    return rejectWithValue(response.errors);
  } catch (error: any) {
    const errors = JSON.parse(error.response).errors;

    dispatch(
      CommonActions.setAlert({
        show: true,
        type: AlertType.ERROR,
        messages: errors || [{ message: 'Something went wrong' }],
      })
    );

    return rejectWithValue(errors);
  }
};

export const getProductGroupByIdWithProducts: ApiMethod<
  number,
  Server.ProductGroupWithProductsOutput
> = async (id, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_ProductGroup_Client(
      undefined,
      paymentClient
    );

    const response = await client.productGroup_byIdWithProducts_get_V1(
      id,
      1,
      null
    );

    if (response.success && response.data) {
      return response.data;
    }

    return rejectWithValue(response.errors);
  } catch (error: any) {
    const errors = JSON.parse(error.response).errors;

    dispatch(
      CommonActions.setAlert({
        show: true,
        type: AlertType.ERROR,
        messages: errors || [{ message: 'Something went wrong' }],
      })
    );

    return rejectWithValue(errors);
  }
};

export const setProductsToProductGroup: ApiMethod<
  Server.SetProductsToProductGroupInput,
  void
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_ProductGroup_Client(
      undefined,
      paymentClient
    );

    const response = await client.productGroup_setProducts_post_V1(data);

    if (response.success) {
      return;
    }

    return rejectWithValue(response.errors);
  } catch (error: any) {
    const errors = JSON.parse(error.response).errors;

    dispatch(
      CommonActions.setAlert({
        show: true,
        type: AlertType.ERROR,
        messages: errors || [{ message: 'Something went wrong' }],
      })
    );

    return rejectWithValue(errors);
  }
};
